// import '../App.css';
// import img1 from '../assets/images/gallery-1.jpeg';
// import img2 from '../assets/images/gallery-2.jpeg';
// import img3 from '../assets/images/gallery-3.jpeg';
// import img4 from '../assets/images/gallery-4.jpeg';
// import img5 from '../assets/images/gallery-5.jpeg';
// import img6 from '../assets/images/gallery-6.jpeg';
// import insta from '../assets/images/instagram.jpeg';
// import tiktok from '../assets/images/tiktok.png';

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "../App.css";

function Gallery() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch("https://family-barbers.com/wp-json/acf/v3/pages/14") // replace 14 with your page ID
      .then((res) => res.json())
      .then((json) => setData(json.acf))
      .catch((err) => console.error(err));
  }, []);

  if (!data) return null;

  // Collect individual images (skip if empty)
  const images = [
    data.gallery_image_1,
    data.gallery_image_2,
    data.gallery_image_3,
    data.gallery_image_4,
    data.gallery_image_5,
    data.gallery_image_6,
  ].filter(Boolean);

  return (
    <div id="gallery" className="section">
      <div className="gallery-content-container">
        <h1>{data.gallery_title || "Gallery"}</h1>
      </div>

      <div className="gallery-image-container">
        {images.map((img, i) => (
          <motion.img key={i} src={img.url} alt={img.alt || `Gallery ${i + 1}`}
            whileInView={{ y: 0, opacity: 1 }}
            initial={{ y: 50, opacity: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1.2, ease: "easeOut" }}
          />
        ))}
      </div>

      <div className="social-parent-container">
        <div className="social-child-container-1">
          <h1>{data.instagram_title || "Follow Our Instagram"}</h1>
          <h3>{data.instagram_subtitle || "Click To Follow"}</h3>
          {data.instagram_image && (
            <a href={data.instagram_link} target="_blank" rel="noopener noreferrer">
              <motion.img
                src={data.instagram_image.url}
                alt={data.instagram_image.alt || "Instagram"}
                whileInView={{ y: 0, opacity: 1 }}
                initial={{ y: 50, opacity: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 1.2, ease: "easeOut" }}
              />
            </a>
          )}
        </div>

        <div className="social-child-container-2">
          <h1>{data.tiktok_title || "Follow Our TikTok"}</h1>
          <h3>{data.tiktok_subtitle || "Click To Follow"}</h3>
          {data.tiktok_image && (
            <a href={data.tiktok_link} target="_blank" rel="noopener noreferrer">
              <motion.img
                src={data.tiktok_image.url}
                alt={data.tiktok_image.alt || "TikTok"}
                whileInView={{ y: 0, opacity: 1 }}
                initial={{ y: 50, opacity: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 1.2, ease: "easeOut" }}
              />
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default Gallery;
